import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { invalidateTaskRelatedQueries } from "@/utils/cacheInvalidation";

type TaskRemoveMemberResponseType = ResponseType<null>;

function useRemoveTaskMemberMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponseAndError<TaskRemoveMemberResponseType>["response"],
    AxiosResponseAndError<TaskRemoveMemberResponseType>["error"],
    string
  >({
    mutationFn: (data) =>
      ApiRequest.delete<TaskRemoveMemberResponseType>(
        `${requestURLs.taskMember}assignment/${data}`
      ),
    onSuccess: () => {
      void invalidateTaskRelatedQueries(queryClient);
    },
  });

  return mutation;
}

export default useRemoveTaskMemberMutation;
